import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'

import './index.css';
import App from './components/App';
import Main from './components/main';
import { unregister } from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.css';

import { Route } from 'react-router-dom';
import store, { history } from './store';

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Route path="/" component={App(Main)} />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

unregister();



// WEBPACK FOOTER //
// ./src/index.js